<template>
  <div>
    <table cellpadding="10" cellspacing="0" width="95%" class="hover-table invoices-table" align="center">
      <thead>
        <tr >
          <td valign="middle">
            <strong>{{ $t("noCrtLabel") }}</strong>
          </td>
          <td @click="() => (sortByField = 'order_date')" valign="middle">
            <strong>{{ $t("ordersTableHeaderDate") }}</strong>&nbsp;
          </td>
          <td @click="() => (sortByField = 'h.orderid')" valign="middle">
            <strong>{{ $t("ordersTableHeaderNumber") }}</strong>&nbsp;
          </td>
          <td class="priority-3" @click="() => (sortByField = 'CODPROD')" valign="middle">
            <strong>{{ $t("ordersTableHeaderProduct") }}</strong>&nbsp;
          </td>
          <!-- <td class="priority-4" valign="middle">
            <strong>{{ $t("ordersTableHeaderType") }}</strong>
            &nbsp;
          </td> -->
          <td class="priority-3"  valign="middle">
            <strong>{{ $t("beneficiariesTableAddress") }}</strong>&nbsp;
          </td>
          <td class="priority-2"  valign="middle">
            <strong>{{ $t("beneficiariesTableCNP") }}</strong>&nbsp;
          </td>
          <td class="priority-2"  valign="middle">
            <strong>{{ $t("beneficiariesTableSurname") }}</strong>&nbsp;
          </td>
          <td class="priority-2"  valign="middle">
            <strong>{{ $t("beneficiariesTableName") }}</strong>&nbsp;
          </td>
          <td class="priority-5" valign="middle">
            <strong>{{ $t("ordersTableHeaderStatus") }}</strong>&nbsp;
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.companyOrders === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(order, index) in companyOrders">
          <tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
            <td valign="middle">
              <a @click="selectOrderMobile(index)" class="detailsOrderMobile priority-show-5 display-inline-block">
                <font-awesome-icon icon="minus-circle" v-if="detailsMobile && order === selectedOrder" />
                <font-awesome-icon icon="plus-circle" v-else />&nbsp;&nbsp;
              </a>
              <span class="crt">{{ index + 1 }}</span>
            </td>
            <td valign="middle">{{ displayDate(order.date) }}</td>
            <td valign="middle">{{ order.muorderid }}</td>
            <td valign="middle" class="priority-3">
              <img :src="
                require('@/assets/images/bullet_' + order.product + '.svg')
              " />
              &nbsp;&nbsp;{{ getProductNameMethod(order.product, order.brand) }}
            </td>
            <td valign="middle" class="priority-3">
              <span>
                {{ getAddressDisplayName(order.details[0].address) }}
              </span>
            </td>
            <!-- <td valign="middle" class="priority-4">
              <img :src="
                require('@/assets/images/product_' + order.product + '.svg')
              " />
            </td> -->
            <td valign="middle" class="priority-2">
              <span>
                {{ order.details[0].from_source_id }}
              </span>
            </td>
            <td valign="middle" class="priority-2">
              <span>
                {{ order.details[0].first_name }}
              </span>
            </td>
            <td valign="middle" class="priority-2">
              <span>
                {{ order.details[0].last_name }}
              </span>
            </td>
            <td valign="middle" class="priority-5">
              <span class="status-background" :class="selectColorStatus(order.status)">
                {{
                  $t(
                    "orderStatus_" +
                    (order.status.length > 2 ? "V2" : order.status)
                  )
                }}
              </span>
            </td>
            </tr>
          <!-- <tr :key="index + companyOrders.length" class="child" :class="index % 2 === 0 && 'gri-cell'"
            v-show="detailsMobile && order === selectedOrder">
            <td colspan="12">
              <p class="priority-show-3">
                <strong>{{ $t("ordersTableHeaderProduct") }} : &nbsp;&nbsp;</strong>
                <span>
                  <img class="product-png" :src="
                    require('@/assets/images/bullet_' +
                      order.product +
                      '.svg')
                  " />
                  &nbsp;&nbsp;{{
                    getProductNameMethod(order.product, order.brand)
                  }}
                </span>
              </p>
              <p class="priority-show-4">
                <strong>{{ $t("ordersTableHeaderType") }} : &nbsp;&nbsp;</strong>
                <span>
                  <img :src="
                    require('@/assets/images/product_' +
                      order.product +
                      '.svg')
                  " />
                </span>
              </p>
              <p class="priority-show-2">
                <strong>{{ $t("ordersTableHeaderAmount") }} : &nbsp;&nbsp;</strong>
                <span>
                  {{ order.total_nominal_value | toCurrency }}
                </span>
              </p>
              <p class="priority-show-5">
                <strong>{{ $t("ordersTableHeaderStatus") }} : &nbsp;&nbsp;</strong>
                <span class="status-background" :class="selectColorStatus(order.status)">
                  {{
                    $t(
                      "orderStatus_" +
                      (order.status.length > 2 ? "V2" : order.status)
                    )
                  }}
                </span>
              </p>
              <-- <p class="priority-show-4">
                <strong>{{ $t("ordersTableHeaderInvoice") }} : &nbsp;&nbsp;</strong>
              </p>-->
              <!-- <p class="priority-show-5">
                <strong>{{ $t("beneficiaryOrderHistory") }} : &nbsp;&nbsp;</strong>
                <span>
                  <a href="#" class="invoice-icon">&nbsp;</a>
                </span>
              </p>--
            </td>
          </tr> -->
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import products from "@/assets/json/products.js";
import utils from "@/plugins/utils.js";
import moment from "moment";

export default {
  name: "OrdersREPLTableDesktop",
  props: {
    companyOrders: Array,
    deliveryAddresses: Array,
  },
  data() {
    return {
      detailsMobile: false,
      sortByField: "order_date",
      selectedOrder: null,
      reverse: false,
    };
  },
  methods: {
    sortBy(fieldName) {
      if (this.sortByField !== fieldName) {
        this.reverse = false;
      }
      this.sortByField = fieldName;
      this.reverse = !this.reverse;
      this.$emit(
        "change",
        fieldName,
        this.reverse ? "asc" : "desc",
        false
      );
    },
    selectOrderMobile(index) {
      if (
        this.selectedOrder !== null &&
        this.selectedOrder.number !== this.companyOrders[index].number
      ) {
        this.detailsMobile = !this.detailsMobile;
      }
      this.selectedOrder = this.companyOrders[index];
      this.detailsMobile = !this.detailsMobile;
    },
    getProductNameMethod(product, brand) {
      return utils.getProductByIdAndBrand(product, brand, products).name;
    },
    selectColorStatus(status) {
      return utils.selectColorStatus(status.length > 2 ? "V2" : status);
    },
    displayDate(date) {
      // moment.setLocale("ro");
      return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
    },
    getAddressDisplayName(addressCode) {
      for (let index in this.deliveryAddresses) {
        if (this.deliveryAddresses[index].codcom === addressCode) {
          return (
            this.deliveryAddresses[index].codcom +
            " - " +
            this.deliveryAddresses[index].address.street_name +
            ", " +
            this.deliveryAddresses[index].address.locality
          );
        }
      } 
    }   
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.padding-5 {
  padding: 5px !important;
}

.track-trace {
  height: 35px;
  align-items: center;
}

.color-blue {
  background: #009bf4 !important;
}

.color-darkblue {
  background: darkblue !important;
}

.nocase {
  text-transform: none !important;
}

@media (max-width: 768px) {
  .orders-page .invoices-filter .vue-daterange-picker {
    width: auto;
  }
}
</style>
